<div class="container-fluid p-3 ed-page">
  <!-- Toolbar -->
  <div class="bp-toolbar d-flex align-items-center gap-2 mb-3 flex-wrap">
    <button type="button" class="btn btn-outline-secondary btn-sm" (click)="back()">
      <i class="bi bi-arrow-left"></i> Zurück
    </button>
    @if (!isNew && orderedIds.length > 1) {
      <!-- Vor/Zurück blättern wie im Katalog-Viewer (auch per Pfeiltasten). -->
      <button type="button" class="btn btn-outline-secondary btn-sm ms-1"
              (click)="prev()" [disabled]="!hasPrev || saving"
              title="Vorheriger Steckbrief (Pfeil links)">
        <i class="bi bi-chevron-left"></i>
      </button>
      <button type="button" class="btn btn-outline-secondary btn-sm"
              (click)="next()" [disabled]="!hasNext || saving"
              title="Nächster Steckbrief (Pfeil rechts)">
        <i class="bi bi-chevron-right"></i>
      </button>
      <span class="text-muted small" title="Position im Katalog">{{ position }}</span>
    }
    @if (isNew) {
      <span class="badge bg-success ms-2"><i class="bi bi-plus-circle"></i> Neuer Steckbrief</span>
    }
    @if (draft) {
      <span class="badge bg-light text-dark border ms-2">
        {{ draft.hauptbodenform.abkuerzung || '–' }}
      </span>
      <strong class="ms-1">{{ draft.hauptbodenform.name || '(ohne Name)' }}</strong>
    }
    <span class="ms-auto d-flex align-items-center gap-2">
      @if (dirty) {
        <span class="text-warning small">
          <i class="bi bi-exclamation-triangle"></i> Ungespeicherte Änderungen
        </span>
      }
      @if (!isNew && draft) {
        <button type="button" class="btn btn-outline-primary btn-sm"
                (click)="viewInReader()"
                title="Diesen Steckbrief im Katalog-Viewer ansehen">
          <i class="bi bi-eye"></i> Ansehen
        </button>
      }
      <button type="button" class="btn btn-outline-secondary btn-sm"
              (click)="openNamensmatrix()"
              title="Namensmatrix: Kürzel × Substrat als klickbare Kreuztabelle">
        <i class="bi bi-grid-3x3-gap"></i> Namensmatrix
      </button>
      <button type="button" class="btn btn-outline-secondary btn-sm"
              (click)="togglePreview()"
              [class.active]="showPreview"
              title="Live-Vorschau (zeigt den aktuellen Bearbeitungsstand neben dem Editor)">
        <i class="bi bi-layout-split"></i> {{ showPreview ? 'Live-Vorschau aus' : 'Live-Vorschau' }}
      </button>
      <button type="button" class="btn btn-outline-secondary btn-sm"
              (click)="toggleOriginal()"
              [class.active]="showOriginal"
              title="Original-PDF-Seite zum Vergleich dazublenden (wird vom Server lazy geladen)">
        <i class="bi bi-file-image"></i> {{ showOriginal ? 'Original aus' : 'Original' }}
      </button>
      <button type="button" class="btn btn-outline-secondary btn-sm" (click)="discard()"
              [disabled]="!dirty" title="Alle ungespeicherten Änderungen verwerfen">
        <i class="bi bi-x-circle"></i> Verwerfen
      </button>
      <button type="button" class="btn btn-primary btn-sm" (click)="save()"
              [disabled]="!dirty || saving" title="Steckbrief in die Liste zurückschreiben">
        <i class="bi bi-download"></i> {{ saving ? 'Speichere…' : 'Speichern' }}
      </button>
    </span>
  </div>

  <div class="ed-content">
  @if (loading) {
    <div class="text-muted">Lade…</div>
  } @else if (notFound) {
    <div class="alert alert-warning">
      Steckbrief nicht gefunden.
    </div>
  } @else if (draft) {

    <div class="row g-3">
      <!-- Editor-Spalte. Bei aktivem Right-Pane (Preview/Original) auf 7/12 schrumpfen. -->
      <div [class.col-xxl-7]="hasRightPane" [class.col-12]="!hasRightPane">

        <!-- HBF-Header -->
        <div class="card mb-3">
          <div class="card-header py-2">
            <strong>Hauptbodenform</strong>
            <small class="text-muted ms-2">
              Mehrere durch <code>/</code> trennen (z.B. „Lehm / Sand" für Split-HBFs)
            </small>
          </div>
          <div class="card-body py-2">
            <div class="row g-2">
              <div class="col-md-6">
                <label class="form-label small mb-1" for="hbf-name">Name</label>
                <input id="hbf-name" type="text" class="form-control form-control-sm"
                       title="Name der Hauptbodenform"
                       [ngModel]="draft.hauptbodenform.name || ''"
                       (ngModelChange)="setHbf('name', $event)">
              </div>
              <div class="col-md-3">
                <label class="form-label small mb-1" for="hbf-abk">Abkürzung</label>
                <input id="hbf-abk" type="text" class="form-control form-control-sm"
                       title="Abkürzung der Hauptbodenform"
                       [ngModel]="draft.hauptbodenform.abkuerzung || ''"
                       (ngModelChange)="setHbf('abkuerzung', $event)">
              </div>
              <div class="col-md-3">
                <label class="form-label small mb-1" for="hbf-substr">Substratgruppe</label>
                <input id="hbf-substr" type="text" class="form-control form-control-sm"
                       title="Substratgruppe (Karteireiter-Buchstabe, z.B. S, L, U)"
                       [ngModel]="draft.hauptbodenform.substratgruppe || ''"
                       (ngModelChange)="setHbf('substratgruppe', $event)">
              </div>
            </div>
          </div>
        </div>

        <!-- Substrat-Layer | Horizont-Diagramm (nebeneinander, 50/50 - links
             Substrat, rechts Horizont-Diagramm, analog zum SEA95-Original). -->
        <div class="row g-3 mb-3">
          <div class="col-md-6">
            <div class="card h-100">
              <div class="card-header py-2 d-flex align-items-center gap-2">
                <strong>Substrat-Layer</strong>
                <small class="text-muted">Substratzeichen + Beschreibung (mehrschichtig)</small>
                <button type="button" class="btn btn-sm btn-success ms-auto"
                        (click)="addSubstratLayer()" title="Substrat-Layer hinzufügen">
                  <i class="bi bi-plus"></i> Layer
                </button>
              </div>
              <div class="card-body py-2">
                @for (layer of substratLayersDraft; track $index; let i = $index) {
                  <div class="row g-2 mb-2 align-items-start">
                    <div class="col-3">
                      <label class="form-label small mb-1" [for]="'subl-k-' + i">Kürzel</label>
                      <input [id]="'subl-k-' + i" type="text"
                             class="form-control form-control-sm"
                             title="Substrat-Kürzel (z.B. S, lS, dL)"
                             [ngModel]="layer.kuerzel"
                             (ngModelChange)="setSubstratLayer(i, 'kuerzel', $event)">
                    </div>
                    <div class="col-7">
                      <label class="form-label small mb-1" [for]="'subl-b-' + i">Beschreibung</label>
                      <textarea [id]="'subl-b-' + i"
                                cdkTextareaAutosize
                                cdkAutosizeMinRows="2"
                                class="form-control form-control-sm"
                                title="Substrat-Beschreibung (Höhe waechst automatisch mit dem Inhalt)"
                                [ngModel]="layer.beschreibung"
                                (ngModelChange)="setSubstratLayer(i, 'beschreibung', $event)"></textarea>
                    </div>
                    <div class="col-2 d-flex align-items-end">
                      <button type="button" class="btn btn-sm btn-outline-danger w-100"
                              (click)="removeSubstratLayer(i)" title="Layer entfernen">
                        <i class="bi bi-trash"></i>
                      </button>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="card h-100 ed-diag-card">
              <div class="card-header py-2 d-flex align-items-center gap-2 flex-wrap">
                <strong>Horizont-Diagramm</strong>
                <small class="text-muted">Profil-Codes + Zonen-Marker</small>
                <button type="button" class="btn btn-sm btn-success ms-auto"
                        [disabled]="!canAddDiagramm"
                        (click)="addDiagramm()"
                        [title]="canAddDiagramm ? 'Weiteres Diagramm hinzufügen' : 'Maximal 4 Diagramme'">
                  <i class="bi bi-plus"></i> Diagramm
                </button>
                <!-- Griechische-Buchstaben-Palette: appended an das zuletzt
                     fokussierte Zonen-Feld (per onZoneFocus gespeichert). -->
                <div class="ed-greek-palette w-100" role="toolbar" aria-label="Griechische Buchstaben">
                  <small class="text-muted me-1" [class.text-danger]="!activeZoneEdit">
                    @if (activeZoneEdit) {
                      Ω → Diagramm {{ activeZoneEdit.diagIdx + 1 }}, Zeile {{ activeZoneEdit.rowIdx + 1 }}
                    } @else {
                      Ω → zuerst ein Zonen-Feld anklicken
                    }
                  </small>
                  @for (g of GREEK_LETTERS; track g) {
                    <button type="button" class="btn btn-sm ed-greek-btn"
                            [disabled]="!activeZoneEdit"
                            (mousedown)="$event.preventDefault()"
                            (click)="insertGreekIntoZone(g)"
                            [attr.title]="g + ' in fokussiertes Zonen-Feld einfügen'">{{ g }}</button>
                  }
                </div>
              </div>
              <div class="card-body py-2">
                @if (diagrammeDraft.length === 0) {
                  <div class="text-muted small fst-italic">Kein Diagramm angelegt.</div>
                }
                <div class="row g-2">
                  @for (diag of diagrammeDraft; track $index; let di = $index) {
                    <div class="col-md-6">
                      <div class="border rounded p-2">
                        <div class="d-flex align-items-center mb-2">
                          <span class="small fw-semibold">Diagramm {{ di + 1 }}</span>
                          <button type="button"
                                  class="btn btn-sm btn-outline-danger ms-auto"
                                  (click)="removeDiagramm(di)" title="Diagramm entfernen">
                            <i class="bi bi-trash"></i>
                          </button>
                        </div>
                        <table class="table table-sm mb-2 ed-diag-table">
                          <thead>
                            <tr>
                              <th class="small">Horizont</th>
                              <th class="small">Zone</th>
                            </tr>
                          </thead>
                          <tbody>
                            <!-- Horizont und Zone sind unabhaengige Spalten: jede
                                 Zelle hat eigene Verschieben/Loeschen-Aktionen, die
                                 NUR die eigene Spalte betreffen. Loeschen schneidet
                                 die Zelle heraus -> die Spalte rueckt nach, die
                                 andere bleibt stehen (Index-Ausrichtung entkoppelt).
                                 Aktionen erscheinen nur an real befuellten Zellen
                                 (ri < colLen) - virtuelle Leerzeilen der kuerzeren
                                 Spalte bekommen keine. -->
                            @for (r of range(diagrammRowCount(diag) || 3); track $index; let ri = $index) {
                              <tr>
                                <td>
                                  <div class="ed-diag-cell">
                                    <input type="text" class="form-control form-control-sm"
                                           placeholder=""
                                           [attr.title]="'Horizont-Symbol Zeile ' + (ri + 1)"
                                           [attr.aria-label]="'Horizont-Symbol Zeile ' + (ri + 1)"
                                           [ngModel]="symOf(diag.horizonte[ri])"
                                           (ngModelChange)="setDiagrammCell(di, ri, 'horizonte', $event)">
                                    @if (ri < colLen(diag, 'horizonte')) {
                                      <div class="ed-row-actions">
                                        <button type="button" class="btn btn-sm"
                                                [disabled]="ri === 0"
                                                (click)="moveDiagrammCell(di, 'horizonte', ri, -1)"
                                                title="Horizont nach oben verschieben">
                                          <i class="bi bi-chevron-up"></i>
                                        </button>
                                        <button type="button" class="btn btn-sm"
                                                [disabled]="ri === colLen(diag, 'horizonte') - 1"
                                                (click)="moveDiagrammCell(di, 'horizonte', ri, 1)"
                                                title="Horizont nach unten verschieben">
                                          <i class="bi bi-chevron-down"></i>
                                        </button>
                                        <button type="button" class="btn btn-sm text-danger"
                                                (click)="removeDiagrammCell(di, 'horizonte', ri)"
                                                title="Horizont-Zelle löschen">
                                          <i class="bi bi-trash"></i>
                                        </button>
                                      </div>
                                    }
                                  </div>
                                </td>
                                <td>
                                  <div class="ed-diag-cell">
                                    <input type="text" class="form-control form-control-sm fst-italic"
                                           placeholder=""
                                           [attr.title]="'Zonen-Symbol Zeile ' + (ri + 1) + ' (Griechische Buchstaben über die Palette oben)'"
                                           [attr.aria-label]="'Zonen-Symbol Zeile ' + (ri + 1)"
                                           [ngModel]="symOf(diag.zonen[ri])"
                                           (focus)="onZoneFocus(di, ri)"
                                           (ngModelChange)="setDiagrammCell(di, ri, 'zonen', $event)">
                                    @if (ri < colLen(diag, 'zonen')) {
                                      <div class="ed-row-actions">
                                        <button type="button" class="btn btn-sm"
                                                [disabled]="ri === 0"
                                                (click)="moveDiagrammCell(di, 'zonen', ri, -1)"
                                                title="Zone nach oben verschieben">
                                          <i class="bi bi-chevron-up"></i>
                                        </button>
                                        <button type="button" class="btn btn-sm"
                                                [disabled]="ri === colLen(diag, 'zonen') - 1"
                                                (click)="moveDiagrammCell(di, 'zonen', ri, 1)"
                                                title="Zone nach unten verschieben">
                                          <i class="bi bi-chevron-down"></i>
                                        </button>
                                        <button type="button" class="btn btn-sm text-danger"
                                                (click)="removeDiagrammCell(di, 'zonen', ri)"
                                                title="Zonen-Zelle löschen">
                                          <i class="bi bi-trash"></i>
                                        </button>
                                      </div>
                                    }
                                  </div>
                                </td>
                              </tr>
                            }
                          </tbody>
                        </table>
                        <button type="button" class="btn btn-sm btn-outline-secondary"
                                (click)="addDiagrammRow(di)" title="Zeile hinzufügen">
                          <i class="bi bi-plus"></i> Zeile
                        </button>
                      </div>
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Sektionen (Hydromorphie / Humus / Eisen / weitere) - sitzt direkt
             oberhalb der Schraffur-Tabelle, in Anlehnung an die SEA95-Vorlage. -->
        <div class="card mb-3">
          <div class="card-header py-2 d-flex align-items-center gap-2">
            <strong>Sektionen</strong>
            <small class="text-muted">Hinweis-Blöcke (Hydromorphie, Humus, etc.)</small>
            <button type="button" class="btn btn-sm btn-success ms-auto"
                    (click)="addSection()" title="Neue Sektion anlegen">
              <i class="bi bi-plus"></i> Sektion
            </button>
          </div>
          <div class="card-body py-2">
            @if (sectionsDraft.length === 0) {
              <div class="text-muted small fst-italic">Keine Sektionen angelegt.</div>
            }
            @for (sec of sectionsDraft; track $index; let si = $index) {
              <div class="border rounded p-2 mb-2">
                <div class="row g-2 align-items-end mb-2">
                  <div class="col-md-7">
                    <label class="form-label small mb-1" [for]="'sec-t-' + si">Titel</label>
                    <input [id]="'sec-t-' + si" type="text" class="form-control form-control-sm"
                           title='Sektions-Titel (z.B. „Humushinweise")'
                           [ngModel]="sec.title"
                           (ngModelChange)="setSectionTitle(si, $event)">
                  </div>
                  <div class="col-md-3">
                    <label class="form-label small mb-1" [for]="'sec-k-' + si">Typ</label>
                    <select [id]="'sec-k-' + si" class="form-select form-select-sm"
                            title="Sektions-Typ - bestimmt die Form des Inhalts"
                            [ngModel]="sec.kind"
                            (ngModelChange)="setSectionKind(si, $event)">
                      <option value="text">Text (Zeilen)</option>
                      <option value="key_value">Key-Value (Marker→Wert)</option>
                      <option value="list">Liste</option>
                    </select>
                  </div>
                  <div class="col-md-2">
                    <button type="button" class="btn btn-sm btn-outline-danger w-100"
                            (click)="removeSection(si)" title="Sektion entfernen">
                      <i class="bi bi-trash"></i> Entfernen
                    </button>
                  </div>
                </div>

                @if (sec.kind === 'key_value') {
                  <table class="table table-sm mb-1">
                    <thead>
                      <tr>
                        <th class="small">Schlüssel</th>
                        <th class="small">Wert</th>
                        <th class="small text-center" aria-label="Aktion">
                          <span class="visually-hidden">Aktion</span>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      @for (kv of kvItems(sec); track kv.key) {
                        <tr>
                          <td>
                            <input type="text" class="form-control form-control-sm"
                                   title="Schlüssel dieses Eintrags (Umbenennen beim Verlassen des Feldes)"
                                   aria-label="Schlüssel"
                                   [ngModel]="kv.key"
                                   (change)="renameKvKey(si, kv.key, $any($event.target).value)">
                          </td>
                          <td>
                            <input type="text" class="form-control form-control-sm"
                                   [title]="'Wert für ' + kv.key"
                                   [ngModel]="kv.value"
                                   (ngModelChange)="updateKvValue(si, kv.key, $event)">
                          </td>
                          <td class="text-center">
                            <button type="button" class="btn btn-sm btn-outline-danger"
                                    (click)="removeKvItem(si, kv.key)" title="Eintrag entfernen">
                              <i class="bi bi-trash"></i>
                            </button>
                          </td>
                        </tr>
                      }
                    </tbody>
                  </table>
                  <button type="button" class="btn btn-sm btn-outline-secondary"
                          (click)="addKvItem(si)" title="Eintrag hinzufügen">
                    <i class="bi bi-plus"></i> Eintrag
                  </button>
                } @else if (sec.kind === 'list') {
                  <label class="form-label small mb-1" [for]="'sec-list-' + si">
                    Einträge (eine Zeile pro Eintrag)
                  </label>
                  <textarea [id]="'sec-list-' + si" rows="4"
                            class="form-control form-control-sm"
                            title="Listen-Einträge, eine pro Zeile"
                            [ngModel]="listItemsText(sec)"
                            (ngModelChange)="setListItems(si, $event)"></textarea>
                } @else {
                  <label class="form-label small mb-1" [for]="'sec-text-' + si">
                    Zeilen (eine pro Zeile)
                  </label>
                  <textarea [id]="'sec-text-' + si" rows="4"
                            class="form-control form-control-sm"
                            title="Text-Zeilen, eine pro Zeile"
                            [ngModel]="textLines(sec)"
                            (ngModelChange)="setTextLines(si, $event)"></textarea>
                }
              </div>
            }
          </div>
        </div>

        <!-- Schraffur-Kreuztabelle -->
        <div class="card mb-3">
          <div class="card-header py-2 d-flex align-items-center gap-2">
            <strong>Schraffur-Tabelle</strong>
            <small class="text-muted">Feinbodenformen × Spalten · Aktionen pro Ebene/Spalte/Zeile direkt in der Tabelle</small>
          </div>

          <div class="card-body p-0">
            <div class="table-responsive ed-scroll">
              <table class="table table-bordered table-sm mb-0 ed-table">
                <thead>
                  @for (lvl of range(nEbenen); track $index) {
                    <tr>
                      <th class="ed-ebene-actions" aria-label="Ebenen-Aktionen">
                        <span class="visually-hidden">Ebenen-Aktionen</span>
                        <div class="ed-row-actions">
                          <button type="button" class="btn btn-sm"
                                  [disabled]="lvl === 0"
                                  (click)="moveEbeneRow(lvl, -1)"
                                  title="Ebene nach oben verschieben">
                            <i class="bi bi-chevron-up"></i>
                          </button>
                          <button type="button" class="btn btn-sm"
                                  [disabled]="lvl === nEbenen - 1"
                                  (click)="moveEbeneRow(lvl, 1)"
                                  title="Ebene nach unten verschieben">
                            <i class="bi bi-chevron-down"></i>
                          </button>
                          <button type="button" class="btn btn-sm"
                                  (click)="insertEbeneRowAt(lvl, 'after')"
                                  title="Leere Ebene darunter einfügen">
                            <i class="bi bi-plus"></i>
                          </button>
                          <button type="button" class="btn btn-sm text-danger"
                                  [disabled]="nEbenen <= 1"
                                  (click)="removeEbeneRowAt(lvl)"
                                  title="Ebene löschen">
                            <i class="bi bi-trash"></i>
                          </button>
                        </div>
                      </th>
                      @if (lvl === 0) {
                        <th [attr.rowspan]="nEbenen + 1" class="ed-fix ed-corner">Lokalname</th>
                        <th [attr.rowspan]="nEbenen + 1" class="ed-fix ed-abk-th">
                          <div class="ed-abk-stack">
                            <div class="ed-abk-label">Abk.</div>
                            <input type="text"
                                   class="form-control form-control-sm ed-klassensuffix-input"
                                   placeholder=""
                                   title="FBF-Klassensuffix (gilt für alle Abkürzungen in dieser Tabelle, im Original-SEA95 als Marker direkt über der ersten Zeile)"
                                   aria-label="FBF-Klassensuffix"
                                   [ngModel]="draft.fbf_klassensuffix || ''"
                                   (ngModelChange)="draft.fbf_klassensuffix = $event; markDirty()">
                          </div>
                        </th>
                      }
                      @for (col of schrafCols; track col) {
                        <th class="ed-ebene" [attr.aria-label]="'Spalte ' + col + ' · Ebene ' + (lvl + 1)">
                          <span class="visually-hidden">Spalte {{ col }} · Ebene {{ lvl + 1 }}</span>
                          <input type="text" class="form-control form-control-sm ed-ebene-input"
                                 placeholder=""
                                 [attr.title]="'Spalte ' + col + ' · Ebene ' + (lvl + 1) + ' (Klick = breite Eingabe)'"
                                 [attr.aria-label]="'Spalte ' + col + ' · Ebene ' + (lvl + 1)"
                                 [ngModel]="ebeneValue(col, lvl)"
                                 (ngModelChange)="setEbene(col, lvl, $event)">
                        </th>
                      }
                      @if (lvl === 0) {
                        @if (hasFootnoteCol) {
                          <th [attr.rowspan]="nEbenen + 1" class="ed-fix text-center ed-fn-th">Fn.</th>
                        }
                        <th [attr.rowspan]="nEbenen + 1" class="ed-fix text-center">NKS</th>
                        <th [attr.rowspan]="nEbenen + 1" class="ed-fix text-center">5tel</th>
                        <th [attr.rowspan]="nEbenen + 1" class="ed-fix">Forstbetrieb</th>
                        <th [attr.rowspan]="nEbenen + 1" class="ed-fix text-center" title="gestrichen?" aria-label="Gestrichen-Spalte">−</th>
                        <th [attr.rowspan]="nEbenen + 1" class="ed-fix text-center" aria-label="Aktionen">
                          <span class="visually-hidden">Aktionen</span>
                        </th>
                      }
                    </tr>
                  }
                  <tr>
                    <th class="ed-ebene-actions ed-ebene-actions-empty" aria-hidden="true"></th>
                    @for (col of schrafCols; track col; let ci = $index) {
                      <th class="ed-colaction text-center" aria-label="Spalten-Aktionen">
                        <span class="visually-hidden">Spalten-Aktionen</span>
                        <div class="ed-col-actions">
                          <button type="button" class="btn btn-sm"
                                  [disabled]="ci === 0"
                                  (click)="moveCol(col, -1)"
                                  title="Spalte nach links verschieben">
                            <i class="bi bi-chevron-left"></i>
                          </button>
                          <button type="button" class="btn btn-sm"
                                  [disabled]="ci === schrafCols.length - 1"
                                  (click)="moveCol(col, 1)"
                                  title="Spalte nach rechts verschieben">
                            <i class="bi bi-chevron-right"></i>
                          </button>
                          <button type="button" class="btn btn-sm"
                                  (click)="insertColAt(col, 'after')"
                                  title="Leere Spalte rechts daneben einfügen">
                            <i class="bi bi-plus"></i>
                          </button>
                          <button type="button" class="btn btn-sm text-danger"
                                  (click)="removeCol(col)"
                                  title="Spalte löschen">
                            <i class="bi bi-trash"></i>
                          </button>
                        </div>
                      </th>
                    }
                  </tr>
                </thead>

                <tbody>
                  @for (f of draft.feinbodenformen; track $index; let i = $index) {
                    <tr [class.ed-row-struck]="f.gestrichen">
                      <td class="ed-ebene-actions-empty" aria-hidden="true"></td>
                      <td>
                        <input type="text" class="form-control form-control-sm"
                               title="Lokalname der Feinbodenform"
                               [ngModel]="f.lokalname"
                               (ngModelChange)="setFbfField(i, 'lokalname', $event)">
                      </td>
                      <td>
                        <input type="text" class="form-control form-control-sm"
                               title="Abkürzung der Feinbodenform"
                               [ngModel]="f.abkuerzung || ''"
                               (ngModelChange)="setFbfField(i, 'abkuerzung', $event)">
                      </td>
                      @for (col of schrafCols; track col) {
                        @let st = cellState(f, col);
                        <td [class]="cellClass(st)"
                            (click)="cycleSchraffur(i, col)"
                            (dblclick)="editSchraffurText(i, col); $event.preventDefault()"
                            [title]="'Klick: leer → Schraffur → X → ? → leer · Doppelklick: Freitext'">
                          {{ cellText(st) }}
                        </td>
                      }
                      @if (hasFootnoteCol) {
                        <td class="ed-fn-td">
                          <input type="text" class="form-control form-control-sm text-center"
                                 title="Fußnoten-Referenz (z.B. 1, 2, ²)"
                                 [ngModel]="f.footnote_ref || ''"
                                 (ngModelChange)="setFbfField(i, 'footnote_ref', $event)">
                        </td>
                      }
                      <td>
                        <input type="text" class="form-control form-control-sm text-center"
                               title="Nährkraftstufe (M / Z / A / K / R, ggf. mit C-Suffix)"
                               [ngModel]="f.nahrkraftstufe || ''"
                               (ngModelChange)="setFbfField(i, 'nahrkraftstufe', $event)">
                      </td>
                      <td>
                        <input type="text" class="form-control form-control-sm text-center"
                               title="Fünftelstufe (1–5)"
                               [ngModel]="f.funftelstufe || ''"
                               (ngModelChange)="setFbfField(i, 'funftelstufe', $event)">
                      </td>
                      <td>
                        <input type="text" class="form-control form-control-sm"
                               title="Forstbetrieb"
                               [ngModel]="f.forstbetrieb || ''"
                               (ngModelChange)="setFbfField(i, 'forstbetrieb', $event)">
                      </td>
                      <td class="text-center">
                        <input type="checkbox" class="form-check-input"
                               title="gestrichene/historische Feinbodenform"
                               [ngModel]="!!f.gestrichen"
                               (ngModelChange)="toggleStruck(i, $event)">
                      </td>
                      <td class="text-center">
                        <div class="ed-row-actions">
                          <button type="button" class="btn btn-sm"
                                  [disabled]="i === 0"
                                  (click)="moveFbf(i, -1)"
                                  title="Zeile nach oben verschieben">
                            <i class="bi bi-chevron-up"></i>
                          </button>
                          <button type="button" class="btn btn-sm"
                                  [disabled]="i === draft.feinbodenformen.length - 1"
                                  (click)="moveFbf(i, 1)"
                                  title="Zeile nach unten verschieben">
                            <i class="bi bi-chevron-down"></i>
                          </button>
                          <button type="button" class="btn btn-sm"
                                  (click)="insertFbfAt(i, 'after')"
                                  title="Leere Zeile darunter einfügen">
                            <i class="bi bi-plus"></i>
                          </button>
                          <button type="button" class="btn btn-sm text-danger"
                                  (click)="removeFbfRow(i)"
                                  title="Zeile löschen">
                            <i class="bi bi-trash"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>

            <div class="p-2 border-top">
              <button type="button" class="btn btn-sm btn-success" (click)="addFbfRow()">
                <i class="bi bi-plus"></i> Feinbodenform hinzufügen
              </button>
            </div>
          </div>
        </div>

        <!-- Fussnoten -->
        <div class="card mb-3">
          <div class="card-header py-2 d-flex align-items-center gap-2">
            <strong>Fußnoten</strong>
            <small class="text-muted">Marker → Erläuterung (unterhalb der Tabelle)</small>
            <button type="button" class="btn btn-sm btn-success ms-auto"
                    (click)="addFussnote()" title="Fußnote hinzufügen">
              <i class="bi bi-plus"></i> Fußnote
            </button>
          </div>
          <div class="card-body py-2">
            @if (fussnotenItems.length === 0 && !fussnotenLinesText) {
              <div class="text-muted small fst-italic">Keine Fußnoten angelegt.</div>
            }
            @if (fussnotenItems.length) {
              <table class="table table-sm mb-2">
                <thead>
                  <tr>
                    <th class="small">Marker</th>
                    <th class="small">Text</th>
                    <th class="small text-center" aria-label="Aktion">
                      <span class="visually-hidden">Aktion</span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  @for (fn of fussnotenItems; track fn.key) {
                    <tr>
                      <td class="ed-fn-marker-cell">
                        <input type="text" class="form-control form-control-sm"
                               title="Marker dieser Fußnote"
                               aria-label="Marker"
                               placeholder=""
                               [ngModel]="fn.key"
                               (ngModelChange)="renameFussnoteMarker(fn.key, $event)">
                      </td>
                      <td>
                        <input type="text" class="form-control form-control-sm"
                               title="Text dieser Fußnote"
                               aria-label="Fußnoten-Text"
                               placeholder=""
                               [ngModel]="fn.value"
                               (ngModelChange)="updateFussnote(fn.key, $event)">
                      </td>
                      <td class="text-center">
                        <button type="button" class="btn btn-sm btn-outline-danger"
                                (click)="removeFussnote(fn.key)" title="Fußnote entfernen">
                          <i class="bi bi-trash"></i>
                        </button>
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            }
            <label class="form-label small mb-1" for="fn-lines">Zusätzliche Zeilen (frei)</label>
            <textarea id="fn-lines" rows="3" class="form-control form-control-sm"
                      title="Zusätzliche Fußnoten-Zeilen ohne Marker, eine pro Zeile"
                      [ngModel]="fussnotenLinesText"
                      (ngModelChange)="setFussnotenLines($event)"></textarea>
          </div>
        </div>

        <!-- Sonstige Felder (Top-Level-Felder ohne dediziertes Editor-UI).
             Read-only - zeigt, was D_Parser sonst noch liefert, damit nichts
             stillschweigend verloren geht. Wenn hier was auftaucht, was
             eigentlich UI-seitig editierbar sein sollte, ergaenze ich das. -->
        @if (unhandledFields.length > 0) {
          <div class="card mb-3">
            <div class="card-header py-2">
              <strong>Sonstige Felder</strong>
              <small class="text-muted ms-2">Im Datensatz vorhanden, aktuell ohne eigenen Editor-Block – bitte melden, falls editierbar werden soll</small>
            </div>
            <div class="card-body py-2">
              <dl class="row mb-0">
                @for (f of unhandledFields; track f.key) {
                  <dt class="col-sm-3 text-truncate small">{{ f.key }}</dt>
                  <dd class="col-sm-9 mb-2">
                    <pre class="ed-raw-pre mb-0">{{ f.value }}</pre>
                  </dd>
                }
              </dl>
            </div>
          </div>
        }

        <!-- Klassifikation / Seitenzahl -->
        <div class="card mb-3">
          <div class="card-header py-2"><strong>Klassifikation &amp; Seitenzahl</strong></div>
          <div class="card-body py-2">
            <div class="row g-2">
              <div class="col-md-8">
                <label class="form-label small mb-1" for="klass">Klassifikation</label>
                <input id="klass" type="text" class="form-control form-control-sm"
                       title='Bodenordnung / Hydromorphie-Begriff (z.B. „anhydromorph")'
                       [ngModel]="draft.klassifikation || ''"
                       (ngModelChange)="draft.klassifikation = $event; markDirty()">
              </div>
              <div class="col-md-4">
                <label class="form-label small mb-1" for="seite">Seitenzahl</label>
                <input id="seite" type="text" class="form-control form-control-sm"
                       title="Seitenzahl im SEA95-Original"
                       [ngModel]="draft.seitenzahl || ''"
                       (ngModelChange)="draft.seitenzahl = $event; markDirty()">
              </div>
            </div>
          </div>
        </div>

      </div>

      <!-- Right-Pane: Original und/oder Live-Vorschau, je nach Toggle. -->
      @if (hasRightPane) {
        <div class="col-xxl-5">
          <div class="ed-preview-sticky d-flex flex-column gap-3">
            @if (showOriginal) {
              <app-sea-original [pdf]="draft.pdf" [page]="draft.page"></app-sea-original>
            }
            @if (showPreview) {
              <div>
                <div class="small text-muted mb-2">
                  <i class="bi bi-eye"></i> Live-Vorschau (aktueller Bearbeitungsstand)
                </div>
                <app-bodensteckbrief-preview [entry]="draft" [embedded]="true">
                </app-bodensteckbrief-preview>
              </div>
            }
          </div>
        </div>
      }
    </div>

  }
  </div>
</div>
